import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  bgColor: string;
  textColor: string;
  children?: React.ReactNode;
  text: string,
};

const BadgeWithChildrenIcon: React.FC<Props> = ({ children, text, bgColor, textColor}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.5,
        borderRadius: '999px',
        backgroundColor: bgColor,
      }}
    >
      { children }
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 500,
          color: textColor,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

export default BadgeWithChildrenIcon;
